import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { errorMessage } from 'lib/styleguide/base.scss'
import { softError } from 'lib/softError'
import { Msg, commonVerbs } from 'lib/localization'
import { tripActions } from 'data/resources/trips'
import { routeActions } from 'data/resources/routes'
import { collectionActions } from 'data/resources/collections'
import _ from 'lodash'
import { FormattedMessage as T } from 'react-intl'
import { withRouter } from 'react-router-dom'

export const DELETE_RECORD_MODAL = 'DELETE_RECORD_MODAL'

class _DeleteRecordModal extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      deletePending: false,
      deleteError: false
    }
  }

  onConfirm = () => {
    const { object, deleteRecord, successPath, reloadPage } = this.props
    this.setState({ deletePending: true })

    deleteRecord(object.id)
      .then(() => {
        if (reloadPage) {
          window.location = successPath || '/'
        } else {
          this.props.history.replace(successPath || '/')
        }
        this.props.onRequestClose()
      })
      .catch(() => this.setState({ deletePending: false, deleteError: true }))
  }

  render () {
    const { objectType, objectName, objectMessage, onRequestClose } = this.props
    const { deletePending, deleteError } = this.state

    return (
      <ConfirmationDialog
        primary danger
        title={<Fragment><Msg capitalized m={commonVerbs.delete} /> <strong>{objectName}</strong>?</Fragment>}
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.onConfirm}
        confirmPending={deletePending}
        confirmText={<T
          id='DeleteRecordModal.permanentlyDelete'
          defaultMessage='Permanently Delete {objectType}'
          values={{ objectType: _.capitalize(objectType) }} />}>
        <p>
          <T
            id='DeleteRecordModal.areYouSure'
            defaultMessage={'Are you sure you want to delete your {item}, <strong>{objectName}</strong>? {lineBreak} This action cannot be undone.'}
            description='A message confirming that the user really wants to delete their information'
            values={{
              strong: (...chunks) => <strong>{chunks}</strong>,
              lineBreak: <br />,
              item: <Msg lowerCase m={objectMessage} values={{ count: 1 }} />,
              objectName
            }} />
        </p>
        {deleteError && <div className={errorMessage}>
          <T
            id='DeleteRecordModal.errorMessage'
            defaultMessage='Oops, we encountered an error while deleting this {objectType}. Please try again.'
            description='A message informing the user that something went wrong'
            values={{ objectType }} />
        </div>}
      </ConfirmationDialog>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let deleteRecord
  switch (ownProps.objectType) {
    case 'trip':
      deleteRecord = (t) => dispatch(tripActions.delete(t))
      break
    case 'route':
      deleteRecord = (r) => dispatch(routeActions.delete(r))
      break
    case 'collection':
      deleteRecord = (c) => dispatch(collectionActions.delete(c))
      break
    default:
      softError(`unrecognized objectType ${ownProps.objectType}`)
  }
  return { deleteRecord }
}

export const DeleteRecordModal = connect(
  null,
  mapDispatchToProps
)(withRouter(_DeleteRecordModal))
